import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { ToastContainer, toast } from "react-toastify";
import { Helmet } from "react-helmet";
import schoolApi from "../../api/schoolApi";
import AddUser from "./AddUser";
import InfoPill from "../InfoPill";
import "react-toastify/dist/ReactToastify.css";
import { usePermissions } from "../contexts/PermissionContext";
import Confirm from "../Confirm";

const UserList = (props) => {
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [rowRecords, setRowRecords] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const { rolePermissions, userInfo } = usePermissions();

  const canCreate = rolePermissions?.UserList?.can_create;
  const canEdit = rolePermissions?.UserList?.can_edit;

  useEffect(() => {
    fetchRecords();
  }, []);

  // const fetchRecords = async () => {
  //   try {
  //     const result = await schoolApi.fetchUsersbyCompanyId();
  //     if (result.success) {
  //       setBody(result.userRec);
  //     } else {
  //       setBody([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching records:", error);
  //     setBody([]);
  //   }
  // };

  const fetchRecords = async () => {
    try {
      const result = await schoolApi.fetchUsersbyCompanyId();
      let filterUser
      console.log("user list == ",result)
      if (result.success) {
        if(userInfo.userrole === "ADMIN"){
          filterUser = result.userRec.filter((item)=>item.userrole !== "SYS_ADMIN" && userInfo.id !== item.id)
        }
        else{
          filterUser = result.userRec.filter((item)=>userInfo.id !== item.id)
        }
        console.log("current user == ",filterUser)
        setBody(filterUser);
      } else {
        setBody([]);
      }
    } catch (error) {
      console.error("Error fetching records:", error);
      setBody([]);
    }
  };

  const addUser = () => {
    setModalShow(true);
    setRowRecords([]);
  };

  const handleEdit = (row) => {
    setModalShow(true);
    setRowRecords(row);
  };

  const acctiveRecord = (row) => {
    if (
      canEdit ||
      userInfo?.userrole === "SYS_ADMIN" ||
      userInfo?.userrole === "ADMIN"
    ) {
      setShowConfirm(true);
      setRowRecords(row);
    }
  };

  const confirmAction = async () => {
    try {
      const updatedRecord = {
        ...rowRecords,
        status: rowRecords?.status === "active" ? "inactive" : "active",
      };
      const response = await schoolApi.updateUser(updatedRecord);
     
      if (response.success) {
        toast.success(response.message);
        fetchRecords();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Internal Server Error");
      console.error(error);
    } finally {
      setShowConfirm(false);
      setRowRecords(null);
    }
  };
  const labels = {
    beforeSelect: " ",
  };
  const header = [
    { title: "First Name", prop: "firstname", isFilterable: true },
    { title: "Last Name", prop: "lastname", isFilterable: true },
    { title: "Email", prop: "email", isFilterable: true },
    { title: "Phone", prop: "phone", isFilterable: true },
    { title: "Role", prop: "userrole", isFilterable: true },
    {
      title: "Status",
      prop: "status",
      cell: (row) => (
        <Button
          className="btn-sm mx-2"
          style={{ width: "80px" }}
          variant={row.status === "active" ? "success" : "danger"}
          onClick={() => acctiveRecord(row)}
        >
          {row.status === "active" ? "Active" : "Inactive"}
        </Button>
      ),
    },
    {
      title: "Actions",
      prop: "id",
      show:
        userInfo?.userrole === "SYS_ADMIN" ||
        userInfo?.userrole === "ADMIN" ||
        canEdit,
      cell: (row) => (
        <Button
          className="btn-sm mx-2 edit-button"
          variant="primary"
          onClick={() => handleEdit(row)}
        >
          <i className="fa-regular fa-pen-to-square"></i>
        </Button>
      ),
    },
  ];

  const recordSaveSuccesfully = () => {
    setModalShow(false);
    fetchRecords();
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Row className="g-0">
        <Col lg={2} className="mx-4">
          <Link className="nav-link" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> User
          </Link>
        </Col>
        <Col lg={12} className="p-lg-3">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 15,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={3}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={5}
                  className="d-flex flex-col justify-content-start align-items-start"
                >
                  <PaginationOptions labels={labels} />
                  <div style={{ marginTop: "5px" }}>
                    <InfoPill left="Total Users" right={body?.length} />
                  </div>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  {(userInfo?.userrole === "SYS_ADMIN" ||
                    userInfo?.userrole === "ADMIN" ||
                    canCreate) && (
                    <Button
                      className="btn-light add-new-button"
                      style={{ color: "black" }}
                      variant="outline-primary"
                      onClick={() => addUser(true)}
                    >
                      Add User
                    </Button>
                  )}
                </Col>
              </Row>
              <Table striped className="data-table custom-table">
                <TableHeader />
                <TableBody />
              </Table>
              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>

      {console.log(" row record data == ",rowRecords)}
      {modalShow && (
        <AddUser
          show={modalShow}
          parent={rowRecords}
          onHide={() => setModalShow(false)}
          recordSaveSuccesfully={recordSaveSuccesfully}
        />
      )}
      {showConfirm && (
        <Confirm
          show={showConfirm}
          onHide={() => setShowConfirm(false)}
          status={confirmAction}
          title="Confirm Status Change"
          message={`Are you sure you want to ${
            rowRecords?.status === "active" ? "deactivate" : "activate"
          } this user?`}
          table="user"
        />
      )}
      <ToastContainer />
    </>
  );
};

export default UserList;